import { Label, SwitcherTab } from '@silverfort/sf-components';
import { AuthenticationsTrafficTab } from '../../hooks/useAuthenticationsTrafficBarChart';

const TABS: { text: string; value: AuthenticationsTrafficTab }[] = [
    {
        text: 'Blocked by deny',
        value: 'blocked'
    },
    {
        text: 'All authentications',
        value: 'all'
    }
];

type AuthenticationsTrafficLayoutProps = {
    selectedTab: AuthenticationsTrafficTab;
    onTabChange: (tab: AuthenticationsTrafficTab) => void;
    children: React.ReactNode;
    className?: string;
};

const AuthenticationsTrafficLayout = ({ children, selectedTab, onTabChange, className }: AuthenticationsTrafficLayoutProps) => {
    return (
        <div className={`box-border flex h-full w-full flex-col rounded-lg border border-sf-gray-100 font-sf hover:border-sf-gray-300 bg-sf-white min-h-[300px] ${className}`}>
            <div className="flex h-12 items-center gap-2 py-2 pl-4 pr-2 flex-shrink-0">
                <div className="flex flex-row gap-2 flex-1">
                    <Label text="Authentications traffic" />
                </div>
                <div className="justify-end">
                    <SwitcherTab items={TABS} onSelect={onTabChange} selectedItem={selectedTab} itemClassName="w-40" />
                </div>
            </div>
            <div className="h-px w-full bg-sf-gray-100 flex-shrink-0" />
            <div className="flex flex-1 items-center justify-center p-4 min-h-0 overflow-hidden">{children}</div>
        </div>
    );
};

export default AuthenticationsTrafficLayout;
